// кнопка шапки на деске

function headerBtn() {
  const menu = document.querySelector('.header__nav');
  const menuBtn = menu.querySelector('button');
  const menuArrow = menuBtn.querySelector('.arrow--size--m');
  const item = menuBtn.closest('li');
  const list = item.querySelector('ul');
  const menuHeight = list.clientHeight + 'px';
  setTimeout(() => {
    list.style.height = '0px';
  }, 1)
  menuBtn.addEventListener('click', function () {
    menuArrow.classList.toggle('true');
    item.classList.toggle('true');
    list.classList.toggle('true');
    if (list.classList.contains('true')) {
      list.style.height = menuHeight;
    } else {
      list.style.height = '0px';
    }

  })

  function remove () {
    menuArrow.classList.remove('true');
    item.classList.remove('true');
    list.classList.remove('true');
  }

  document.addEventListener('click', (e) => {
    let click = e.composedPath().includes(item);
    if (!click) {
      remove()
    } else {

    }
  })

}

export {
  headerBtn
}
